<template>
  <div
    class="icono-ocupado"
    :class="['icono-ocupado', { 'icon-occupant-active': !user.done || allColors, 'thin-border': thinBorder }]">
    {{ getFirstLetter(user.nombre) }}
  </div>
</template>

<script setup>
  defineProps({
    user: {
      type: Object,
      default: () => ({}),
    },
    allColors: {
      type: Boolean,
      default: false,
    },
    thinBorder: {
      type: Boolean,
      default: false,
    },
  });

  function getFirstLetter(name) {
    return name ? name.charAt(0).toUpperCase() : '';
  }
</script>

<style scoped>
  .icono-ocupado {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    background-color: var(--bs-white);
    border: 3px solid var(--bs-primary);
    border-radius: 50%;
    color: var(--bs-primary);
    font-size: 30px;
    font-weight: bold;
  }

  .icon-occupant-active {
    background-color: var(--bs-primary);
    border: 1px solid var(--bs-secondary);
    color: var(--bs-secondary);
  }

  .thin-border {
    border: 1px solid var(--bs-secondary);
  }

  .landing-experiencia .icono-ocupado {
    background-color: transparent;
    border-color: var(--landing-detail-color, var(--bs-primary));
    color: var(--landing-detail-color, var(--bs-primary));
  }

  .landing-experiencia .icon-occupant-active {
    background-color: transparent;
    border-color: var(--landing-detail-color, var(--bs-secondary));
    color: var(--landing-detail-color, var(--bs-secondary));
  }

  .landing-experiencia .thin-border {
    border-color: var(--landing-detail-color, var(--bs-secondary));
  }
</style>
